export default {
  brand: {},
}
